import { render, staticRenderFns } from "./GjwCategoryDisplay.vue?vue&type=template&id=519597cc&scoped=true&"
import script from "./GjwCategoryDisplay.vue?vue&type=script&lang=js&"
export * from "./GjwCategoryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GjwCategoryDisplay.vue?vue&type=style&index=0&id=519597cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519597cc",
  null
  
)

export default component.exports